import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import DetailsSup from "./components/suppliers/detailsSup";
import Suppliers from "./components/suppliers/suppliers";
import UpdateSup from "./components/suppliers/updateSup";

import Product from "./components/product/product";
import DetailsProd from "./components/product/detailsProd";
import UpdateProd from "./components/product/updateProd";
import UpdateRunningSize from "./components/product/updateRunningSize";
import BulkAddRunningSize from "./components/product/BulkAddRunningSize";

import DetailsPurch from "./components/purchase/detailsPurch";
import Purchase from "./components/purchase/purchase";

import Login from "./components/user/Login";
import Logout from "./components/user/Logout";
import UserList from "./components/user/user";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Customer from "./components/customer/customer";
import DetailCust from "./components/customer/detailCust";
import UpdateCust from "./components/customer/updateCust";
import Pos from "./components/pos/pos";
import DetailSale from "./components/sale/detailSale";

import Page404 from "./components/404/404Page";
import Dashboard from "./components/Dashboard/Graph/Dashboard";
import AddCustPaymentByInvoice from "./components/Payment/CustomerPaymentByInvoice";
import AddSupPaymentByInvoice from "./components/Payment/SupplierPaymentByInvoice";
import UpdateProductBrand from "./components/productBrand/updateProductBrand";
import UpdateProductSubcategory from "./components/ProductSubcategory/updateProductSubcategory";
import GetAllPurch from "./components/purchase/getAllPurch";
import GetAllSale from "./components/sale/getAllSale";
import DetailStaff from "./components/user/detailsStaff";
import UpdateStaff from "./components/user/updateStaff";

// import Register from "./components/user/Register";
import Account from "./components/account/account";
import BalanceSheet from "./components/account/balanceSheet";
import DetailAccount from "./components/account/detailAccount";
import IncomeStatement from "./components/account/incomeStatement";
import TrialBalance from "./components/account/trialBalance";
import Designation from "./components/designation/designation";
import DetailDesignation from "./components/designation/detailDesignation";
import UpdateDesignation from "./components/designation/updateDesignation";
import Main from "./components/layouts/Main";
import DetailProductBrand from "./components/productBrand/detailProductBrand";
import ProductBrand from "./components/productBrand/productBrand";
import DetailProductCategory from "./components/productCategory/detailProductCategory";
import ProductCategory from "./components/productCategory/productCategory";
import UpdateProductCategory from "./components/productCategory/updateProductCategory";
import DetailProductSubCategory from "./components/ProductSubcategory/detailProductSubcategory";
import ProductSubcategory from "./components/ProductSubcategory/productSubcategory";
import AddReturnPurchase from "./components/purchase/addReturnPurchase";
import AddPermission from "./components/role/AddPermission";
import DetailRole from "./components/role/DetailsRole";
import RoleList from "./components/role/role";
import AddReturnSale from "./components/sale/addReturnSale";
import InvoiceSetting from "./components/settings/invoiceSetting";
import AddTransaction from "./components/transaction/AddTransaction";
import DetailTransaction from "./components/transaction/detailTransaction";
import Transaction from "./components/transaction/transaction";

import RateCalculator from "./components/rateCalculator/rateCalculator";
import BatchRateCalculator from "./components/rateCalculator/BatchRateCalculator";
import SheetSizeRateCalculator from "./components/rateCalculator/SheetSizeRateCalculator";
import RateLogList from "./components/rateCalculator/RateLogList";
import QuotationList from "./components/quotation/QuotationList";
import QuotationForm from "./components/quotation/QuotationForm";
import QuotationDetail from "./components/quotation/QuotationDetail";
import { OrderList, OrderDetail, OrderForm } from "./components/order";
import { KanbanBoard } from "./components/kanban";
import BatchKanban from "./components/kanban/BatchKanban";
import PrintTemplateConsole from "./components/print-templates/PrintTemplateConsole";
import BatchPlanning from "./components/batch-planning/BatchPlanning";
import BatchDetail from "./components/batch-planning/BatchDetail";
import { JobList, JobDetail, WorkInstructionPrint } from "./components/job";
import {
	InventoryDashboard,
	MaterialShortages,
	ExcessStock,
	GRNList,
	GRNForm,
	RawMaterialList,
	NonConsumableList,
	QuickStockEntry,
	InventoryConsumptionHistory,
	InventorySettlement,
} from "./components/inventory";
import ProductionDashboard from "./components/Dashboard/ProductionDashboard";
import BusinessDashboard from "./components/Dashboard/BusinessDashboard";
import ReportGenerator from "./components/Dashboard/Reports/ReportGenerator";
import ProductionFlowList from "./components/settings/ProductionFlowList";
import ProductionFlowEditor from "./components/settings/ProductionFlowEditor";
import StageConfigManager from "./components/settings/StageConfigManager";
import LayerTemplateManager from "./components/settings/LayerTemplateManager";
import { MRPDashboard } from "./components/mrp";
import { SchedulingLayout } from "./components/scheduling";
import { OutsourceJobList, OutsourceJobDetail, VendorPerformance } from "./components/outsource";
import { WastageLayout } from "./components/wastage";
import DispatchPlanning from "./components/dispatch/DispatchPlanning";
import { MachineList, MachineDetail, MachineForm } from "./components/machine";
import WorkerList from "./components/hr/WorkerList";
import AddWorker from "./components/hr/AddWorker";
import WorkerDetail from "./components/hr/WorkerDetail";
import UpdateWorker from "./components/hr/UpdateWorker";
import AttendancePage from "./components/hr/AttendancePage";
import AdvancePage from "./components/hr/AdvancePage";
import SalarySheetPage from "./components/hr/SalarySheetPage";
import { ItemGroupList, ItemGroupForm } from "./components/itemGroup";
import ErrorBoundary from "./components/ErrorBoundary";
function App() {
	return (
		<div className='App container-fluid'>
			<BrowserRouter>
			  <ErrorBoundary>
				<Main>
					<ToastContainer />
					<Routes>
						<Route path='/dashboard' element={<Dashboard />}></Route>
						<Route path='/dashboard/production' element={<ProductionDashboard />} />
						<Route path='/dashboard/business' element={<BusinessDashboard />} />
						<Route path='/reports' element={<ReportGenerator />} />
						<Route path='/' element={<Dashboard />} />
						<Route path='*' element={<Page404 />} />

						<Route path='/supplier' exact element={<Suppliers />} />
						<Route path='/supplier/:id' element={<DetailsSup />} />
						<Route path='/supplier/:id/update' element={<UpdateSup />} />

						<Route path='/product' exact element={<Product />} />
						<Route path='/product/:id' element={<DetailsProd />} />
						<Route path='/product/:id/update' element={<UpdateProd />} />
						<Route path='/running-size/:id/update' element={<UpdateRunningSize />} />
						<Route path='/running-size/bulk-add' element={<BulkAddRunningSize />} />

						<Route
							path='/product-category'
							exact
							element={<ProductCategory />}
						/>
						<Route
							path='/product-category/:id'
							element={<DetailProductCategory />}
						/>
						<Route
							path='/product-category/:id/update'
							element={<UpdateProductCategory />}
						/>

						<Route
							path='/product-subcategory'
							exact
							element={<ProductSubcategory />}
						/>
						<Route
							path='/product-subcategory/:id'
							element={<DetailProductSubCategory />}
						/>

						<Route
							path='/product-subcategory/:id/update'
							element={<UpdateProductSubcategory />}
						/>

						<Route path='/product-brand' exact element={<ProductBrand />} />
						<Route path='/product-brand/:id' element={<DetailProductBrand />} />
						<Route
							path='/product-brand/:id/update'
							element={<UpdateProductBrand />}
						/>

						<Route path='/purchase' exact element={<Purchase />} />
						<Route path='/purchaselist' exact element={<GetAllPurch />} />
						<Route path='/purchase/:id' element={<DetailsPurch />} />
						<Route
							path='/purchase/return/:id'
							element={<AddReturnPurchase />}
						/>

						<Route path='/customer' exact element={<Customer />} />
						<Route path='/customer/:id' element={<DetailCust />} />
						<Route path='/customer/:id/update' element={<UpdateCust />} />
						<Route path='/salelist' exact element={<GetAllSale />} />
						<Route path='/sale/:id' element={<DetailSale />} />
						{/* <Route path='/sale/:id/update' element={<UpdateProd />} /> */}
						<Route path='/sale/return/:id' element={<AddReturnSale />} />
						<Route
							path='/payment/supplier/:pid'
							exact
							element={<AddSupPaymentByInvoice />}
						/>
						<Route
							path='/payment/customer/:pid'
							exact
							element={<AddCustPaymentByInvoice />}
						/>
						<Route path='/transaction' exact element={<Transaction />} />
						<Route
							path='/transaction/create'
							exact
							element={<AddTransaction />}
						/>
						<Route path='/transaction/:id' element={<DetailTransaction />} />

						<Route path='/auth/login' exact element={<Login />} />
						<Route path='/auth/logout' exact element={<Logout />} />
						{/*         <Route path='/auth/register' exact element={<Register />} /> */}
						<Route path='/hr/staffs' exact element={<UserList />} />
						<Route path='/hr/staffs/:id' exact element={<DetailStaff />} />
						<Route path='/hr/staffs/:id/update' element={<UpdateStaff />} />

						<Route path='/hr/workers' exact element={<WorkerList />} />
						<Route path='/hr/workers/add' exact element={<AddWorker />} />
						<Route path='/hr/workers/:id' element={<WorkerDetail />} />
						<Route path='/hr/workers/:id/update' element={<UpdateWorker />} />
						<Route path='/hr/attendance' exact element={<AttendancePage />} />
						<Route path='/hr/advance' exact element={<AdvancePage />} />
						<Route path='/hr/salary' exact element={<SalarySheetPage />} />

						<Route path='/item-group' exact element={<ItemGroupList />} />
						<Route path='/item-group/new' exact element={<ItemGroupForm />} />
						<Route path='/item-group/:id/edit' element={<ItemGroupForm />} />

						<Route path='/role' exact element={<RoleList />} />
						<Route path='/role/:id' element={<DetailRole />} />
						<Route path='/role/permit/:id/' element={<AddPermission />} />

						<Route path='/account' exact element={<Account />} />
						<Route path='/account/:id' element={<DetailAccount />} />
						<Route
							path='/account/trial-balance'
							exact
							element={<TrialBalance />}
						/>
						<Route
							path='/account/balance-sheet'
							exact
							element={<BalanceSheet />}
						/>
						<Route path='/account/income' exact element={<IncomeStatement />} />
						<Route path='/designation' exact element={<Designation />} />
						<Route path='/designation/:id' element={<DetailDesignation />} />
						<Route
							path='/designation/:id/update'
							element={<UpdateDesignation />}
						/>

						<Route path='/pos' exact element={<Pos />} />

						<Route path='/invoice-setting' exact element={<InvoiceSetting />} />

						<Route path='/settings/production-flow' exact element={<ProductionFlowList />} />
						<Route path='/settings/production-flow/new' exact element={<ProductionFlowEditor />} />
						<Route path='/settings/production-flow/:id' element={<ProductionFlowEditor />} />
						<Route path='/settings/stage-config' exact element={<StageConfigManager />} />
						<Route path='/settings/print-templates' exact element={<PrintTemplateConsole />} />
						<Route path='/settings/layer-templates' exact element={<LayerTemplateManager />} />

						<Route path='/quotation' exact element={<QuotationList />} />
						<Route path='/quotation/new' exact element={<QuotationForm />} />
						<Route path='/quotation/:id' element={<QuotationDetail />} />
						<Route path='/quotation/:id/edit' element={<QuotationForm />} />

						<Route path='/order' exact element={<OrderList />} />
						<Route path='/order/new' exact element={<OrderForm />} />
						<Route path='/order/:id' element={<OrderDetail />} />
						<Route path='/order/:id/edit' element={<OrderForm />} />

						<Route path='/production/kanban' exact element={<KanbanBoard />} />
						<Route path='/production/batch-kanban' exact element={<BatchKanban />} />
						<Route path='/production/scheduling' exact element={<SchedulingLayout />} />
						<Route path='/production/batch-planning' exact element={<BatchPlanning />} />
						<Route path='/batch/:id' exact element={<BatchDetail />} />

						{/* Machine Management */}
						<Route path='/machine' exact element={<MachineList />} />
						<Route path='/machine/new' element={<MachineForm />} />
						<Route path='/machine/:id' element={<MachineDetail />} />
						<Route path='/machine/:id/edit' element={<MachineForm />} />

						<Route path='/job' exact element={<JobList />} />
						<Route path='/job/:id' element={<JobDetail />} />
						<Route path='/job/:jobId/instructions/print' element={<WorkInstructionPrint />} />
						<Route path='/work-instruction/:instructionId/print' element={<WorkInstructionPrint />} />

						<Route path='/inventory' exact element={<InventoryDashboard />} />
						<Route path='/inventory/shortages' exact element={<MaterialShortages />} />
						<Route path='/inventory/excess' exact element={<ExcessStock />} />
						<Route path='/inventory/grn' exact element={<GRNList />} />
						<Route path='/inventory/grn/new' exact element={<GRNForm />} />
						<Route path='/inventory/grn/:id/edit' element={<GRNForm />} />

						<Route path='/inventory/raw-materials' exact element={<RawMaterialList />} />
						<Route path='/inventory/non-consumables' exact element={<NonConsumableList />} />
						<Route path='/inventory/add-stock' exact element={<QuickStockEntry />} />
						<Route path='/inventory/history' exact element={<InventoryConsumptionHistory />} />
						<Route path='/inventory/settlement' exact element={<InventorySettlement />} />

						<Route path='/mrp' exact element={<MRPDashboard />} />

						<Route path='/outsource' exact element={<OutsourceJobList />} />
						<Route path='/outsource/vendors/performance' element={<VendorPerformance />} />
						<Route path='/outsource/:id' element={<OutsourceJobDetail />} />

						<Route path='/wastage' exact element={<WastageLayout />} />

						<Route path='/dispatch-planning' exact element={<DispatchPlanning />} />

						<Route path='/calculate-rate' exact element={<RateCalculator />} />
						<Route path='/sheet-size-calculator' exact element={<SheetSizeRateCalculator />} />
						<Route path='/batch-calculator' exact element={<BatchRateCalculator />} />
						<Route path='/rate-logs' exact element={<RateLogList />} />
					</Routes>
				</Main>
			  </ErrorBoundary>
			</BrowserRouter>
		</div>
	);
}

export default App;
